import * as React from 'react'
import { ReactElement } from 'react'
import { makeStyles } from '@fluentui/react-components'
import { bundleIcon, DeleteFilled, DeleteRegular } from '@fluentui/react-icons'
import { tokens } from '@fluentui/react-theme'
import AlertDialog from './AlertDialog'
import { useTranslation } from 'react-i18next'

type Props = {
    className?: string
    // Property to prevent the click event inside the dialog to reach elements outside the dialog which in turn cause the dialog to close.
    setPreventDefaultEvent?: (value: boolean) => void
    onDelete?: (setOpen: (open: boolean) => void, setSubmitting: (submitting: boolean) => void) => void
    disabled?: boolean
}

const DeleteIcon = bundleIcon(DeleteFilled, DeleteRegular)

const useStyles = makeStyles({
    deleteButton: {
        backgroundColor: tokens.colorPaletteRedForeground3,
        '&:hover, &:active': {
            backgroundColor: `${tokens.colorPaletteRedForeground1} !important`,
        },
        '&:hover:active': {
            backgroundColor: `${tokens.colorPaletteRedForeground2} !important`,
        },
    },
})

export default function DeleteDialog(props: Props): ReactElement {
    const styles = useStyles()
    const { t: translate } = useTranslation()

    return (
        <AlertDialog
            className={props.className}
            onConfirm={props.onDelete}
            title={translate('base.delete.title')}
            content={translate('base.delete.subtitle')}
            triggerButtonProps={{
                appearance: 'transparent',
                icon: <DeleteIcon />,
                children: translate('base.delete.submit'),
                disabled: props.disabled,
            }}
            confirmButtonProps={{
                icon: <DeleteIcon />,
                className: styles.deleteButton,
            }}
        />
    )
}
